import * as React from 'react';

export const NoResultImageBoron = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={148}
      height={148}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{'Illustration/Web/Search'}</title>
      <defs>
        <filter x="-10.8%" y="-7%" width="121.7%" height="120%" filterUnits="objectBoundingBox" id="a">
          <feOffset dy={6} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feOffset in="SourceAlpha" result="shadowOffsetOuter2" />
          <feGaussianBlur stdDeviation={1.5} in="shadowOffsetOuter2" result="shadowBlurOuter2" />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
            in="shadowBlurOuter2"
            result="shadowMatrixOuter2"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="shadowMatrixOuter2" />
          </feMerge>
        </filter>
        <filter x="-9.7%" y="-26.6%" width="119.5%" height="194.8%" filterUnits="objectBoundingBox" id="c">
          <feMorphology radius={1.129} operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
          <feOffset dy={4} in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.244459843 0 0 0 0 0.270513549 0 0 0 0 0.341230752 0 0 0 0.369372815 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id="d" x={26.718} y={42.564} width={93.656} height={19.252} rx={9.626} />
        <path
          d="M41.118 15.754h66.094a8.465 8.465 0 0 1 8.465 8.466v97.867a8.465 8.465 0 0 1-8.465 8.466H41.118a8.465 8.465 0 0 1-8.465-8.466V24.22a8.465 8.465 0 0 1 8.465-8.466Z"
          id="b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <path
            d="M0 138.406V28.388a9.594 9.594 0 0 1 9.594-9.594H110.27a9.594 9.594 0 0 1 9.594 9.594v110.018A9.594 9.594 0 0 1 110.27 148H9.594A9.594 9.594 0 0 1 0 138.406Z"
            fillOpacity={0.73}
            fill="#042261"
            opacity={0.046}
          />
          <path
            d="M28.137 119.612V9.594A9.594 9.594 0 0 1 37.73 0h100.675A9.594 9.594 0 0 1 148 9.594v110.018a9.594 9.594 0 0 1-9.594 9.594H37.73a9.594 9.594 0 0 1-9.594-9.594Z"
            fillOpacity={0.73}
            fill="#042261"
            opacity={0.046}
          />
          <g transform="rotate(90 74.165 73.154)">
            <use fill="#000" filter="url(#a)" xlinkHref="#b" />
            <use fill="#FFF" xlinkHref="#b" />
          </g>
          <path fill="#5A6479" opacity={0.1} d="M27.172 94.62h93.656v7.22H27.172zM27.172 82.587h93.656v7.22H27.172z" />
          <rect fill="#5A6479" opacity={0.1} x={27.172} y={52.506} width={93.656} height={22.862} rx={10.984} />
          <use fill="#000" filter="url(#c)" xlinkHref="#d" />
          <rect
            stroke="#A0A0A3"
            strokeWidth={1.129}
            fillOpacity={0.59}
            fill="#FFF"
            x={26.153}
            y={42}
            width={94.785}
            height={20.381}
            rx={10.19}
          />
          <path
            d="M37.329 54.17a3.47 3.47 0 0 1-3.464-3.466 3.47 3.47 0 0 1 3.464-3.466 3.47 3.47 0 0 1 3.465 3.466 3.47 3.47 0 0 1-3.465 3.466m7.019 1.695-3.37-2.747a4.356 4.356 0 0 0 .727-2.414 4.383 4.383 0 0 0-4.376-4.379 4.382 4.382 0 0 0-4.376 4.379 4.382 4.382 0 0 0 4.376 4.379 4.358 4.358 0 0 0 3.069-1.261l3.374 2.75a.456.456 0 1 0 .576-.707"
            fill="#A0A0A3"
          />
        </g>
        <path d="M-12-12h172v172H-12z" />
      </g>
    </svg>
  );
};
